import * as yup from 'yup';

export const callMeBackSchema = () =>
  yup.object({
    phoneNumber: yup
      .string()
      .required('Campo Obbligatorio')
      .min(9, 'Il campo deve avere almeno 9 cifre')
      .max(11, 'Il campo deve avere massimo 11 cifre'),
    timeSlot: yup.string().required('Campo Obbligatorio'),
  });

export const callMeSchema = () =>
  yup.object({
    phoneNumber: yup
      .string()
      .required('Campo Obbligatorio')
      .min(9, 'Il campo deve avere almeno 9 cifre')
      .max(11, 'Il campo deve avere massimo 11 cifre'),
  });
